<template>
  <div class="brands-page staff page inner-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Staff"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="1">
                <v-select
                  v-model="sortQuery"
                  flat
                  solo
                  prepend-inner-icon="filter_alt"
                  hide-details
                  append-icon="arrow_drop_down"
                  :items="['name', 'email', 'location']"
                ></v-select>
              </v-col> -->
              <!-- <v-col cols="2">
                <v-btn :ripple="false" depressed class="gen-button">
                  <v-icon>add_circle_outline</v-icon>
                  <span>Add Staff Roles</span>
                </v-btn>
              </v-col> -->
              <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="openStaff"
                  depressed
                  class="gen-button white--text"
                  color="#60a45f"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Staff</span>
                </v-btn>
              </v-col>
              <!-- <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="bulkUploadStaff"
                  depressed
                  class="gen-button"
                >
                  <v-icon>backup</v-icon>
                  <span>Upload List</span>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>

          <div class="main-body-content main-x-spacing">
            <v-row>
              <!-- <pre></pre> -->
              <v-col cols="10">
                <v-data-table
                  :headers="headers"
                  :items="filteredSearchResult"
                  item-key="id"
                  class="elevation-0 dataTableUI staffTable border-me-light"
                >
                  <!-- For Staff Image -->
                  <template v-slot:[`item.profileImage`]="{ item }">
                    <img
                      class="round-avatar mt-2"
                      :src="item.profileImage || require('@/assets/avatar.png')"
                    />
                  </template>

                  <!-- For Staff Name -->
                  <template v-slot:[`item.firstName`]="{ item }">
                    {{ item.firstName }} {{ item.lastName }}
                  </template>

                  <!-- For Staff Role -->
                  <template v-slot:[`item.userType`]="{ item }">
                    <span v-for="(role, index) in userTypes" :key="index">
                      <span v-if="item.userType == role.id">{{
                        role.name
                      }}</span>
                    </span>
                  </template>

                  <!-- For Location -->
                  <template v-slot:[`item.location`]="{ item }">
                    <span v-if="item.location">{{
                      item.location.locationName
                    }}</span>
                  </template>

                  <!-- For Actions -->
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      :ripple="false"
                      x-small
                      text
                      class="white py-4 btn-outlined"
                      @click="openStaff('editMode', item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      x-small
                      text
                      class="white py-4 btn-outlined mx-2"
                      ><v-icon>history</v-icon></v-btn
                    >
                    <v-btn
                      :ripple="false"
                      text
                      x-small
                      class="white py-4 btn-outlined"
                      @click="deleteStaff(item.id)"
                      ><v-icon>delete_forever</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="2" class="col-2-side-tab">
                <div
                  class="switch-tab no-bg"
                  :class="{ activeSwitchTab: filterDataBy == '' }"
                >
                  <v-btn
                    :ripple="false"
                    text
                    depressed
                    width="100%"
                    left
                    class="justify-start transparent switch-tab gen-button no-Btn-bg"
                    @click="
                      filterDataBy = '';
                      currentSwitchTab = '';
                    "
                  >
                    All Roles
                  </v-btn>
                </div>
                <div
                  v-for="(role, index) in userTypes"
                  :key="index"
                  :class="{ activeSwitchTab: role.id == currentSwitchTab }"
                  class="switch-tab"
                >
                  <v-btn
                    :ripple="false"
                    text
                    depressed
                    width="100%"
                    left
                    class="justify-start transparent switch-tab gen-button no-Btn-bg"
                    @click="
                      filterDataBy = role.id;
                      $forceUpdate();
                      currentSwitchTab = role.id;
                    "
                  >
                    {{ role.name }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>

          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Staff -->
                <div v-if="addNewStaffActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Staff</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="6"
                        ><v-text-field
                          v-model="firstName"
                          hide-details
                          outlined
                          placeholder="First Name"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="6"
                        ><v-text-field
                          v-model="lastName"
                          hide-details
                          outlined
                          placeholder="Last Name"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12"
                        ><v-text-field
                          v-model="email"
                          :disabled="editMode"
                          hide-details
                          outlined
                          placeholder="Email Address"
                          :rules="[rules.required, rules.email]"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12"
                        ><v-text-field
                          v-model="password"
                          hide-details
                          disabled
                          class="login-input"
                          outlined
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          label="Auto Generated"
                          @click:append="show1 = !show1"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12"
                        ><div><b>Assign Location:</b></div>
                        <v-select
                          v-model="location"
                          hide-details
                          outlined
                          placeholder="Select Location"
                          append-icon="arrow_drop_down"
                          :items="enterpriseLocations"
                          item-text="locationName"
                          item-value="id"
                        ></v-select
                      ></v-col>
                      <v-col cols="12"
                        ><div>Role:</div>
                        <v-select
                          v-model="userType"
                          hide-details
                          outlined
                          placeholder="Select Role"
                          append-icon="arrow_drop_down"
                          :items="userTypes"
                          item-text="name"
                          item-value="id"
                        ></v-select
                      ></v-col>
                      <v-col cols="12"
                        ><div class="d-flex align-end">
                          <div
                            v-if="isSelected == false"
                            class="uploadHolder uploadPreview mb-2"
                          ></div>
                          <div v-if="isSelected == true">
                            <v-img
                              contain
                              class="uploadSrc"
                              max-height="300"
                              max-width="300"
                              :src="url"
                            ></v-img>
                          </div>
                          <div>
                            <div class="">
                              <div class="uploadButtonWrapper v-btn">
                                <v-file-input
                                  v-model="image"
                                  color="black"
                                  @change="previewImage"
                                  @click:clear="clearSelected"
                                  hide-details
                                  placeholder="Upload File"
                                  class="text-capitalize uploadButton"
                                  flat
                                  solo
                                  ref="staffImgUpload"
                                  prepend-inner-icon="publish"
                                  :rules="[rules.required]"
                                >
                                  <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">
                                      {{ text }}
                                    </v-chip>
                                  </template>
                                </v-file-input>
                                <!-- <v-btn @click="testUpload">TT</v-btn> -->
                                <!-- isSelected is =>{{ isSelected }} -->
                              </div>

                              <!-- <span class="ml-4">No File Chosen</span> -->
                            </div>
                            <p class="caption">
                              Accepts JPG and PNG files only.
                            </p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="
                        openDialog = false;
                        editMode = false;
                        addNewStaffActive;
                      "
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <!-- <v-btn
                      :ripple="false"
                      @click="clearSelected"
                      class="grey--text mr-3"
                    >
                      Cancel 2
                    </v-btn> -->
                    <v-btn
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addEditStaff()"
                    >
                      Ok
                    </v-btn>
                  </div>
                </div>

                <!-- Upload List -->
                <div v-if="bulkUploadStaffActive" class="formLayerCard">
                  <h2 class="dialog-form-title">User Bulk Upload</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <p class="text-center">
                      <b>
                        Please select the CSV/EXcel file you want to batch
                        upload.
                      </b>
                    </p>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                    ></vue-dropzone>

                    <p style="margin-top: 100px" class="text-center">
                      Please download a sample file that shows how your list
                      should be created
                      <v-btn :ripple="false" class="mt-10">
                        <v-icon>get_app</v-icon>
                        <span class="text-capitalize">
                          Download Sample File
                        </span>
                      </v-btn>
                    </p>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="
                        openDialog = false;
                        bulkUploadStaffActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                  </div>
                </div>

                <!-- User Login History -->
                <div v-if="userLoginHistoryActive" class="formLayerCard">
                  <h2 class="dialog-form-title">User Login History</h2>
                  <div class="dialog-body">
                    <table class="tableUI staffHistoryTable">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Login Time</th>
                          <th>Logout Time</th>
                        </tr>
                      </thead>
                      <tbody v-if="!true">
                        <tr v-for="(staff, index) in tempStaff" :key="index">
                          <td>{{ staff.name }}</td>
                          <td>{{ staff.role }}</td>
                          <td>{{ staff.location }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr style="background-color: #f9f9f9">
                          <td colspan="3" class="text-center py-2">
                            No history found
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="
                        openDialog = false;
                        userLoginHistoryActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                  </div>
                </div>

                <!-- User Login History -->
                <div v-if="userLoginHistoryActive" class="formLayerCard">
                  <h2 class="dialog-form-title">User Login History</h2>
                  <div class="dialog-body">
                    <table class="tableUI staffHistoryTable">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Login Time</th>
                          <th>Logout Time</th>
                        </tr>
                      </thead>
                      <tbody v-if="!true">
                        <tr v-for="(staff, index) in tempStaff" :key="index">
                          <td>{{ staff.name }}</td>
                          <td>{{ staff.role }}</td>
                          <td>{{ staff.location }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr style="background-color: #f9f9f9">
                          <td colspan="3" class="text-center py-2">
                            No history found
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="
                        openDialog = false;
                        userLoginHistoryActive;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      title: "Staff",
      dataReady: false,
      show1: false,
      loader: false,
      deleteLoader: false,
      loaderNum: -1,
      editMode: false,
      editModeId: "",
      disablePassword: false,
      currentSwitchTab: "",
      filterDataBy: "",
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "profileImage",
        },
        {
          text: "Staff Name",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Staff Role",
          value: "userType",
          sortable: false,
        },
        {
          text: "Current Location",
          value: "location",
        },
        {
          text: "Email Address",
          align: "start",
          value: "email",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ],
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      location: "",
      userType: "",
      role: "",
      isSelected: false,
      url: "a",
      image: [], // must be an array
      openDialog: false,
      addNewStaffActive: false,
      bulkUploadStaffActive: false,
      userLoginHistoryActive: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class=''><i class='fa fa-cloud-upload fa-4x'></i><br> Drag and drop a file here or Click to select a file</p>`,
      },
      rules: {
        required: (value) => !!value || "Required",
        email: (value) =>
          !value ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          "Invalid E-mail",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      searchQuery: "",
      sortQuery: "",
    };
  },
  methods: {
    emptyForm() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.location = "";
      this.userType = "";
      this.clearSelected();
    },
    deleteStaff(id) {
      //   Start Loader
      this.deleteLoader = true;

      axios
        .delete(
          "/api/v1/staff/" + id,
          {
            data: {
              id: id,
            },
            headers: { Authorization: this.$store.state.token },
          },
          {
            id: id,
          }
        )
        .then(() => {
          this.$store.dispatch("getEnterpriseDetails");

          this.snackBar.active = true;
          this.snackBar.text = "Staff deleted successfully";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.deleteLoader = false;
        })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error deleting Staff";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.deleteLoader = false;
        });
    },
    openStaff(edit, data) {
      if (edit == "editMode") {
        this.editMode = true;
        this.editModeId = data.id;

        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.location = data.locationId;
        this.userType = data.userType;
        this.url = data.profileImage;

        // Make image preview show if image exists

        this.url ? (this.isSelected = true) : (this.isSelected = false);

        this.addNewStaffActive = true;
        this.openDialog = true;
      } else {
        this.addNewStaffActive = true;
        this.openDialog = true;
      }
    },
    async addEditStaff() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;

        const staff = new FormData();
        staff.append("firstName", this.firstName);
        staff.append("lastName", this.lastName);
        staff.append("email", this.email);
        staff.append("locationId", this.location);
        staff.append("userType", this.userType);
        staff.append("profileImage", this.image);
        if (this.image) {
          staff.append("profileImage", this.image);
        }

        let route;
        let reqType;

        // if this.editMode is true, modify to put request
        if (this.editMode == true) {
          route = "/api/v1/staff/" + this.editModeId;
          staff.append("id", this.editModeId);

          // delete email in edit mode
          staff.delete("email");
          if (!this.image.type) {
            // delete profileImage if there's no change
            staff.delete("profileImage");
          }
        } else {
          route = "/api/v1/staff/";
        }

        this.editMode == true ? (reqType = "put") : (reqType = "post");

        axios({
          method: reqType,
          url: route,
          headers: { Authorization: this.$store.state.token },
          data: staff,
        })
          .then(() => {
            // Refresh staff list
            this.$store.dispatch("getEnterpriseDetails");

            this.loader = false;

            this.addNewStaffActive = false;
            this.openDialog = false;

            // empty fields
            this.emptyForm();
          })
          .catch((error) => {
            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error with request";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;

            this.loader = false;
          });
      }
    },
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.isSelected = false;
      this.url = "";

      this.$refs.staffImgUpload.value.name = null;
    },
    bulkUploadStaff() {
      this.bulkUploadStaffActive = true;
      this.openDialog = true;
    },
    userLoginHistory() {
      this.userLoginHistoryActive = true;
      this.openDialog = true;
    },
  },
  watch: {
    openDialog(val) {
      if (val == false) {
        this.editMode = false;
        this.editModeId = "";
        this.emptyForm();
      }
    },
    editMode(val) {
      if (val == true) {
        this.disablePassword = true;
      }
    },
    staff(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.staff;
      const filterDataBy = this.filterDataBy;

      if (filterDataBy) {
        grabArr = grabArr.filter((user) => user.userType == filterDataBy);
      }

      return grabArr.filter((item) => {
        if (
          item.firstName
            .toLowerCase()
            .indexOf(this.searchQuery.toLowerCase()) !== -1 || // search by first name
          item.lastName
            .toLowerCase()
            .indexOf(this.searchQuery.toLowerCase()) !== -1 || // search by last name
          item.email.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !==
            -1 // search by email
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "staff", "enterpriseLocations", "userTypes"]),
  },
  created() {},
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
    vueDropzone: vue2Dropzone,
  },
};
</script>

<style></style>
